module.exports = __webpack_public_path__ + "static/Anahita-Medhora.dafc6041.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Anahita-Medhora.jpg
// module id = 910
// module chunks = 146520050992020